import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, computed, effect, inject } from '@angular/core';
import {
  FormControl,
  FormsModule,
  NG_VALUE_ACCESSOR,
  ReactiveFormsModule,
} from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ResultFilterComponent } from '../result-filter/result-filter.component';
import { MatNativeDateModule } from '@angular/material/core';
import { TranslateDirective, TranslatePipe } from '@ngx-translate/core';
import {
  MatSlideToggleModule,
} from '@angular/material/slide-toggle';
import { ManipulationsToolbarStore } from 'src/app/store/manipulations-toolbar-store';
import { toSignal } from '@angular/core/rxjs-interop';
import { ToggleComponent } from '../toggle/toggle.component';
import { Observable, catchError, filter, map, of } from 'rxjs';
import { GlobalStore } from 'src/app/store/global-store';
import { environment } from 'src/environment';
import { NavigationEnd, Router } from '@angular/router';
import { DateRange, DateRangeTypeEnum, PageTypeEnum } from '../../models/filter.model';
import {  EnumApprovalsTabs, EnumRecordsTypes } from 'src/app/models/approval.model';
import { ApprovalApiService } from 'src/app/services/approvals-api.service';
import { DateSelectComponent } from "../date-select/date-select.component";
import { ConnectedPosition, OverlayModule } from '@angular/cdk/overlay';
import { MatDialog } from '@angular/material/dialog';
import { PopupExportPayrollConfirmComponent } from 'src/app/features/approvals/components/popup-export-payroll-confirm/popup-export-payroll-confirm.component';

@Component({
    selector: 'que-manipulations-toolbar',
    templateUrl: './manipulations-toolbar.component.html',
    styleUrls: ['./manipulations-toolbar.component.scss'],
    providers: [
        {
            provide: NG_VALUE_ACCESSOR,
            useExisting: ManipulationsToolbarComponent,
            multi: true,
        },
    ],
    imports: [
        FormsModule,
        ReactiveFormsModule,
        CommonModule,
        ResultFilterComponent,
        MatNativeDateModule,
        TranslateDirective, TranslatePipe,
        MatSlideToggleModule,
        ToggleComponent,
        DateSelectComponent,
        OverlayModule
    ],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ManipulationsToolbarComponent implements OnInit {
  @Input() displaySlideToggleType?: string;
  @Input() isTowViews?: boolean;
  @Input() isQuestionnariePage?: boolean;
  @Input() isEmpty?: boolean;
  enumPage = PageTypeEnum;
  enumRecordsTypes = EnumRecordsTypes;
  enumApprovalsTabs = EnumApprovalsTabs;
  filter = new FormControl<string | null>(null);
  #manipulationsToolbarStore = inject(ManipulationsToolbarStore);
  #globalStore = inject(GlobalStore);
  #approvalApiService = inject(ApprovalApiService);
  #router = inject(Router);
  #dialog = inject(MatDialog);
  isDisplayNotActiveItems$ = toSignal(this.#manipulationsToolbarStore.isDisplayNotActiveItems$.pipe(filter(x => x != undefined)));
  isFilterListOpen$ = toSignal(this.#manipulationsToolbarStore.isFilterListOpen$);
  client = environment.client;
  selectedFilter$ = toSignal(this.#manipulationsToolbarStore.selectedFilter$);
  isListView$ = toSignal(this.#manipulationsToolbarStore.isListView$);
  pendingApprovalTab$ = toSignal(this.#manipulationsToolbarStore.pendingApprovalTab$);
  afterApprovalTab$ = toSignal(this.#manipulationsToolbarStore.afterApprovalTab$);
  downloadRecordsTab$ = toSignal(this.#manipulationsToolbarStore.downloadRecordsTab$);
  reportsTab$ = toSignal(this.#manipulationsToolbarStore.reportsTab$);
  lastUrlSegment = "";
  isRoleAdmim$ = toSignal(this.#globalStore.isRoleAdmin$);
  isApproverManager$ = toSignal(this.#globalStore.isApproverManager$);
  isPayrollRepresentative$ = toSignal(this.#globalStore.isPayrollRepresentative$);
  isAccountingRepresentative$ = toSignal(this.#globalStore.isAccountingRepresentative$);
  isBillingRepresentative$ = toSignal(this.#globalStore.isBillingRepresentative$);
  pageType$ = toSignal(this.#manipulationsToolbarStore.pageType$);
  isHistory?: boolean = false;
  isDownloadDropdownOpen = false;
  showTabApprovers = this.#globalStore.showTabApprovers;
  showTabRecords = this.#globalStore.showTabRecords;
  countTabs = computed(() =>
    Number(this.showTabApprovers()) + Number(this.showTabRecords())
  );
  readonly positonArea = [{
    originX: 'center',
    originY: 'center',
    overlayX: 'end',
    overlayY: 'top',
  }] as ConnectedPosition[];
  private updateLastUrlSegment(url: string): void {
    const segments = url.split('/');
    this.lastUrlSegment = segments[segments.length - 1];
  }

  constructor() {
    effect(() => {
      if (this.isRoleAdmim$() != undefined && !this.isRoleAdmim$()) {
        this.#manipulationsToolbarStore.updateFilterDataSelected({
          myQuestionnaires: true,
          generalQuestionnaires: false
        });
      }
    }, { allowSignalWrites: true });
  }
  ngOnInit(): void {
    this.#router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.updateLastUrlSegment(event.url);
      }
    });

    this.updateLastUrlSegment(this.#router.url);

    this.filter.valueChanges.subscribe(f => {
      this.filterQuestionnaires(f);
    });

    this.#manipulationsToolbarStore.selectedFilter$.pipe(
      map(x => x?.filterByName),
      filter(filterByName => filterByName != this.filter.value)
    ).subscribe(filterByName =>
      this.filter.setValue(filterByName ?? null, { emitEvent: false })
    );
  }

  changeToGridView() {
    this.#manipulationsToolbarStore.updateViewState(false);
  }

  changeToListView() {
    this.#manipulationsToolbarStore.updateViewState(true);
  }

  filterQuestionnaires(e: any) {
    // .trim()
    const inputValue = this.filter.value ?? "";
    this.#manipulationsToolbarStore.updateFilterDataSelected({ 'filterByName': inputValue });
    // this.#manipulationsToolbarStore.updateTitle({ id: 0, name: this.filter.value ? this.filter.value : '', enName: this.filter.value ? this.filter.value : '' })
  }

  changeActiveState(ev: boolean) {
    this.#manipulationsToolbarStore.updateIsDisplayNotActiveItems(ev)
  }
  resetFilters(event: Event) {
    event.stopPropagation();
    this.#manipulationsToolbarStore.resetFilters();
  }
  // Same fix as FilterTypeComponent.filterExists: a filter cleared back to null (yes/no toggles,
  // number/range fields) still leaves its key in selectedFilter with a null value - Object.keys
  // alone can't tell that apart from an actually-selected value, so this also excludes null/undefined.
  #activeFilterKeys(): string[] {
    const filter = this.selectedFilter$();
    if (!filter) return [];
    return Object.keys(filter).filter(x =>
      x != 'filterByName' && x != 'myQuestionnaires' && x != 'generalQuestionnaires' && x != 'approvalsTabs'
      && (filter as any)[x] !== null && (filter as any)[x] !== undefined
    );
  }
  filterExists(): boolean {
    return this.#activeFilterKeys().length > 0;
  }
  filterNumber() {
    return this.#activeFilterKeys().length;
  }
  resetInput() {
    this.filter.setValue('');
  }
  ChnageIsOpenFilter() {
    this.#manipulationsToolbarStore.changeOpenFilterList();
  }

  toggleMyQuestionnaires() {
    const currentFilter = this.selectedFilter$();
    const isMyQuestionnaire = currentFilter?.myQuestionnaires ?? false;
    if (!isMyQuestionnaire) {
      this.#manipulationsToolbarStore.resetFilters();
      this.#manipulationsToolbarStore.updateFilterDataSelected({ myQuestionnaires: true, generalQuestionnaires: false });
    }
  }

  toggleGeneralQuestionnaires() {
    const currentFilter = this.selectedFilter$();
    const isGeneralQuestionnaires = currentFilter?.generalQuestionnaires ?? false;
    if (!isGeneralQuestionnaires) {
      this.#manipulationsToolbarStore.resetFilters();
      this.#manipulationsToolbarStore.updateFilterDataSelected({ generalQuestionnaires: true, myQuestionnaires: false });
    }
  }

  toggleAllQuestionnaires() {
    const currentFilter = this.selectedFilter$();
    if (currentFilter?.generalQuestionnaires || currentFilter?.myQuestionnaires)
      this.#manipulationsToolbarStore.resetFilters();
    this.#manipulationsToolbarStore.updateFilterDataSelected({ generalQuestionnaires: false, myQuestionnaires: false });
  }

  toggleApprovalsTab(approvalsTab: EnumApprovalsTabs) {
    this.#manipulationsToolbarStore.switchApprovalsTab(approvalsTab);
  }

  toggleDownloadRecords() {

  }

  
  downloadRecord(type: EnumRecordsTypes) {
    this.isDownloadDropdownOpen = false;

    if (type === EnumRecordsTypes.PayrollRepresentative) {
      // The export itself ignores the grid's search/date filters (see backend FetchPayrollData),
      // so the confirmation must show the real export scope, not the (possibly search-filtered)
      // on-screen totals$. The warning must still appear even if this count fetch fails - it
      // never gates whether the user gets asked to confirm, only what number is shown.
      this.#approvalApiService.getPayrollExportCount()
        .pipe(catchError(() => of(null)))
        .subscribe(count => {
          this.#dialog.open(PopupExportPayrollConfirmComponent, {
            panelClass: 'dialog-panel',
            data: { count }
          }).afterClosed().subscribe(confirmed => {
            if (confirmed) {
              this.#approvalApiService.downloadRecord(this.selectedFilter$(), 'approvals.xlsx', type);
            }
          });
        });
      return;
    }

    this.#approvalApiService.downloadRecord(this.selectedFilter$(), 'approvals.xlsx', type);
  }

  exportReportsToExcel(): void {
    this.#approvalApiService.exportReportsToExcel(this.selectedFilter$());
  }

  toggleDownloadDropdown(event: MouseEvent): void {
    event.stopPropagation();
    if (this.downloadRecordsTab$())
      this.isDownloadDropdownOpen = true;

    if (this.afterApprovalTab$())
      this.downloadRecord(EnumRecordsTypes.ApproverManager);
  }
}
